import { Loader2 } from "lucide-react";

export const IconAction = ({ onClick, Icon, label, testid, tone = "slate", disabled = false, busy = false }) => {
  const tones = {
    slate: "text-slate-500 hover:text-slate-900 hover:bg-slate-100",
    primary: "text-primary hover:bg-primary/10",
    danger: "text-rose-500 hover:text-rose-700 hover:bg-rose-50",
  };
  return (
    <span className="relative inline-flex group/ia">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || busy}
        data-testid={testid}
        aria-label={label}
        className={`h-7 w-7 rounded-md inline-flex items-center justify-center transition disabled:opacity-50 ${tones[tone]}`}
      >
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Icon className="h-3.5 w-3.5" />}
      </button>
      <span className="pointer-events-none absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-md bg-slate-900 px-2 py-1 text-[10px] font-medium text-white opacity-0 group-hover/ia:opacity-100 transition-opacity z-20">
        {label}
      </span>
    </span>
  );
};
